import { PhotoshopController } from "../photoshopController.js";
declare global {
    interface JQueryStatic {
        contextMenu(options: any): any;
    }
}

export class MenuWidget {
    parentElement: HTMLElement;
    photoshopController: PhotoshopController;
    onSaveCallback: any;
    constructor(parentElement: HTMLElement, controller: PhotoshopController, onSaveCallback: any) {
        this.parentElement = parentElement;
        this.photoshopController = controller;
        this.onSaveCallback = onSaveCallback;
    }

    static html() {
        return `
        <div style="height: 32px; display: flex;">
            <button id="file-menu">Fichier</button>
            <button id="image-menu">Image</button>
            <button id="filter-menu">Filtre</button>
            <button id="preset-menu">Preset</button>
        </div>
        <div class="divider" style="background-color: #282828"></div>
        `;
    }

    buildMenu() {
        var fileMenuItems = {}
        fileMenuItems['open'] = {
            name: 'Ouvrir',
            className: 'contextmenu-item',
            callback: function (key, opt) {
                this.photoshopController.open();
            }.bind(this)
        }
        if (this.onSaveCallback) {
            fileMenuItems['save'] = {
                name: "Enregistrer",
                className: 'contextmenu-item',
                callback: function (key, opt) {
                    var pixels = this.photoshopController.PSEngine.grabImage();
                    if (pixels) {
                        this.onSaveCallback(pixels);
                    }
                }.bind(this)
            }
        }
        fileMenuItems['download'] = {
            name: "Télécharger",
            className: 'contextmenu-item',
            items: {
                png: {
                    name: 'PNG',
                    className: 'contextmenu-item',
                    callback: function (key, opt) {
                        this.photoshopController.download('image/png', 1, '.png');
                    }.bind(this)
                },
                jpg: {
                    name: 'JPEG',
                    className: 'contextmenu-item',
                    callback: function (key, opt) {
                        this.photoshopController.download('image/jpeg', 0.94, '.jpg');
                    }.bind(this)
                }
            }
        }
        var appendTo = document.getElementById('photoshop-container');
        $.contextMenu({
            selector: '#file-menu',
            appendTo: appendTo,
            className: 'contextmenu',
            trigger: 'left',
            position: function (opt, x, y) {
                var parent = document.querySelector(opt.selector);
                opt.$menu.css({ top: parent.offsetHeight + parent.offsetTop, left: parent.offsetLeft });
            },
            items: fileMenuItems
        });

        $.contextMenu({
            selector: '#image-menu',
            appendTo: appendTo,
            className: 'contextmenu',
            trigger: 'left',
            position: function (opt, x, y) {
                var parent = document.querySelector(opt.selector);
                opt.$menu.css({ top: parent.offsetHeight + parent.offsetTop, left: parent.offsetLeft });
            },
            items: {
                settings: {
                    name: 'Réglages',
                    className: 'contextmenu-item',
                    items: {
                        luminosity: {
                            name: 'Luminosité/Contrast',
                            className: 'contextmenu-item',
                            callback: function (key, opt) {
                                this.photoshopController.setActiveOperation('luminosityContrast');
                            }.bind(this)
                        },
                        levels: {
                            name: 'Niveaux',
                            className: 'contextmenu-item',
                            callback: function (key, opt) {
                                this.photoshopController.setActiveOperation('levels');
                            }.bind(this)
                        },
                        tint: {
                            name: 'Teinte/Saturation',
                            className: 'contextmenu-item',
                            callback: function (key, opt) {
                                this.photoshopController.setActiveOperation('hueSaturation');
                            }.bind(this)
                        },
                        balance: {
                            name: 'Balance des couleurs',
                            className: 'contextmenu-item',
                            callback: function (key, opt) {
                                this.photoshopController.setActiveOperation('colorBalance');
                            }.bind(this)
                        },
                        alpha2color: {
                            name: 'Alpha vers couleur',
                            className: 'contextmenu-item',
                            callback: function (key, opt) {
                                this.photoshopController.setActiveOperation('alpha2color');
                            }.bind(this)
                        }
                    }
                },
            }
        });

        $.contextMenu({
            selector: '#filter-menu',
            appendTo: appendTo,
            className: 'contextmenu',
            trigger: 'left',
            position: function (opt, x, y) {
                var parent = document.querySelector(opt.selector);
                opt.$menu.css({ top: parent.offsetHeight + parent.offsetTop, left: parent.offsetLeft });
            },
            items: {
                enhancement: {
                    name: 'Renforcement',
                    className: 'contextmenu-item',
                    items: {
                        sharpen: {
                            name: 'Netteté',
                            className: 'contextmenu-item',
                            callback: function (key, opt) {
                                this.photoshopController.setActiveOperation('sharpen');
                            }.bind(this)
                        }
                    }
                }
            }
        });

        $.contextMenu({
            selector: '#preset-menu',
            appendTo: appendTo,
            className: 'contextmenu',
            trigger: 'left',
            position: function (opt, x, y) {
                var parent = document.querySelector(opt.selector);
                opt.$menu.css({ top: parent.offsetHeight + parent.offsetTop, left: parent.offsetLeft });
            },
            items: {
                unreal_afters: {
                    name: 'UNREAL : Afters et panoramique',
                    className: 'contextmenu-item',
                    callback: function (key, opt) {
                        this.photoshopController.unreal_after();
                    }.bind(this)
                },
                unreal_axos: {
                    name: 'UNREAL : Axos',
                    className: 'contextmenu-item',
                    callback: function (key, opt) {
                        this.photoshopController.unreal_axo();
                    }.bind(this)
                },
                unreal_night: {
                    name: 'UNREAL : Nuit',
                    className: 'contextmenu-item',
                    callback: function (key, opt) {
                        this.photoshopController.unreal_night();
                    }.bind(this)
                }
            }
        });
    }

    destroy() {
        ($('#file-menu') as any).contextMenu('destroy');
        ($('#image-menu') as any).contextMenu('destroy');
        ($('#filter-menu') as any).contextMenu('destroy');
        ($('#preset-menu') as any).contextMenu('destroy');
    }
}